module.exports = __webpack_public_path__ + "static/media/homeHeroImage.645dd3fb.png";